export enum ExperienceType {
    NonBfi = 0,
    BfiRepaid = 1,
    BfiOutstanding = 2,
}
